define('service__share_text',['bootstrap', 'service__number_translate'], function (news, Numbers) {

    function manualOverride(vocab, score, outOf) {
        if (vocab.socialMediaMessage) {
            return vocab.socialMediaMessage;
        }
        return false;
    }

    var defaultShareTextDictionary = {

        defaultShareText: function (vocab, score, outOf) {
            return vocab.my_score.replace('{{quiz_title}}', vocab.quizTitle) + ' ' + Numbers.translate(vocab, score, outOf) + ' ' + vocab.complete_yours;
        },

        news: function (vocab, score, outOf) {
            var title  = vocab.quizTitle.length === 0 ? '' : vocab.quizTitle + ' ';
            var aVsThe = vocab.quizTitle.length === 0 ? 'on a' : 'on the';
            var message = 'I scored ' + score + ' out of ' + outOf + ' ' + aVsThe + ' ' + vocab.org + ' ' + title + vocab.quiz;
            return message;
        }

    };

    return {
        get: function (vocab, score, outOf) {
            var functionToCall          = defaultShareTextDictionary['defaultShareText'],
                serviceSpecificFunction = defaultShareTextDictionary[vocab.service],
                manualShareMessage      = manualOverride(vocab, score, outOf);

            if (manualShareMessage) {
                return manualShareMessage;
            }

            if (typeof serviceSpecificFunction !== 'undefined') {
                functionToCall = serviceSpecificFunction;
            }

            return functionToCall(vocab, score, outOf);
        }
    };

});

